import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _objectSpread from "@babel/runtime-corejs2/helpers/esm/objectSpread";
import React, { Component } from 'react';
import { Provider } from 'react-redux';
import Logger from '../../../logger';
var debug = false;
var DEFAULT_KEY = process.env.STORE_KEY || '__FIL_REDUX_STORE__';
/**
 * @param makeStore
 * @param initialState
 * @param config
 * @return {{getState: function, dispatch: function}}
 */

var initStore = function initStore(_ref) {
  var makeStore = _ref.makeStore,
      initialState = _ref.initialState,
      config = _ref.config;
  var storeKey = config.storeKey;

  var createStore = function createStore() {
    return makeStore(config.deserializeState(initialState), _objectSpread({}, config));
  }; // Memoize store


  if (!window[storeKey]) {
    window[storeKey] = createStore();
  }

  return window[storeKey];
};
/**
 * @param makeStore
 * @param config
 * @return {function(App): {getInitialProps, new(): WrappedApp, prototype: WrappedApp}}
 */


export default (function (makeStore) {
  var configObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var config = _objectSpread({
    storeKey: DEFAULT_KEY,
    debug: debug,
    serializeState: function serializeState(state) {
      return state;
    },
    deserializeState: function deserializeState(state) {
      return state;
    }
  }, configObj);

  return function (App) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_Component) {
      _inherits(WrappedApp, _Component);

      function WrappedApp(props, context) {
        var _this;

        _classCallCheck(this, WrappedApp);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(WrappedApp).call(this, props, context));
        var store = props.store;
        var initialState = props.initialState;
        var hasStore = store && 'dispatch' in store && 'getState' in store;
        store = hasStore ? store : initStore({
          makeStore: makeStore,
          initialState: initialState,
          config: config
        });
        if (config.debug) Logger.log('WrappedApp.render', hasStore ? 'picked up existing one,' : 'created new store with', 'initialState', initialState);
        _this.store = store;
        return _this;
      }

      _createClass(WrappedApp, [{
        key: "render",
        value: function render() {
          var _this$props = this.props,
              initialState = _this$props.initialState,
              store = _this$props.store,
              props = _objectWithoutProperties(_this$props, ["initialState", "store"]);

          return React.createElement(Provider, {
            store: this.store
          }, React.createElement(App, _extends({}, props, {
            store: this.store
          })));
        }
      }]);

      return WrappedApp;
    }(Component), _class.displayName = "withRedux(".concat(App.displayName || App.name || 'App', ")"), _temp;
  };
});